export const VERSION_NUMBER = '3.800';
export const BUILD_TIME = 'BUILD_TIME_VALUE';
export const BUILD_REASON = `
<ul>
    <li>Added college contact tools for admins to specify contacts for email notifications.</li>
    <li>Modify admin tools to accept multiple colleges.</li>
</ul>`;



// WEBPACK FOOTER //
// ./src/services/version/version.service.ts